import { useId } from 'react';
import { styled } from '@mui/material/styles';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import Button from '@components/Button';

export const aiGradientBorder = {
    border: '1px solid transparent',
    backgroundImage: 'linear-gradient(#fff, #fff), var(--ai-gradient)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
};

export const AiBlock = styled('div')({
    padding: 12,
    borderRadius: 8,
    ...aiGradientBorder,
});

const StyledButton = styled(Button)({
    backgroundColor: '#fff',
    ...aiGradientBorder,
    transition: 'box-shadow 0.2s ease',
    '&:hover': {
        backgroundColor: '#fff',
        ...aiGradientBorder,
        boxShadow: 'var(--ai-glow)',
    },
    '& .MuiButton-startIcon svg': {
        fill: 'var(--ai-icon-fill)',
    },
    '&.Mui-disabled': {
        backgroundImage: 'none',
        opacity: 0.6,
    },
});

export const AiText = styled('span')({
    background: 'var(--ai-gradient)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
});

const useGradientId = () => `pl-ai-gradient-${useId().replace(/:/g, '')}`;

const GradientDefs = ({ id }) => (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" style={{ stopColor: 'var(--ai-gradient-start)' }} />
            <stop offset="55%" style={{ stopColor: 'var(--ai-gradient-mid)' }} />
            <stop offset="100%" style={{ stopColor: 'var(--ai-gradient-end)' }} />
        </linearGradient>
    </svg>
);

export const AiIcon = ({ size = 16 }) => {
    const gradientId = useGradientId();
    return (
        <>
            <GradientDefs id={gradientId} />
            <AutoAwesomeRoundedIcon sx={{ width: size, height: size, fill: `url(#${gradientId})`, flexShrink: 0 }} />
        </>
    );
};

const AiButton = ({ children, style, ...rest }) => {
    const gradientId = useGradientId();
    return (
        <StyledButton
            variant="outlined"
            startIcon={<AutoAwesomeRoundedIcon />}
            style={{ '--ai-icon-fill': `url(#${gradientId})`, ...style }}
            {...rest}
        >
            <GradientDefs id={gradientId} />
            <AiText>{children}</AiText>
        </StyledButton>
    );
};

export default AiButton;
